/* fk-premium.js: hamburger drop-down menu, product-card sliders, product tabs, size-guide sheet */
(function () {
  'use strict';

  /* ---------- hamburger drop-down ---------- */
  function initMenu() {
    var burger = document.querySelector('.fk-burger');
    var menu = document.getElementById('fk-menu');
    var back = document.querySelector('.fk-menu-backdrop');
    if (!burger || !menu || burger.dataset.fkInit) return;
    burger.dataset.fkInit = '1';
    function set(open) {
      document.documentElement.classList.toggle('fk-menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      if (back) back.hidden = !open;
    }
    burger.addEventListener('click', function () { set(menu.hidden); });
    if (back) back.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
  }


  /* ---------- hover controls on product cards: image arrows + quick view button ---------- */
  function handleFrom(card) {
    var a = card && card.querySelector('.fk-slide');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function addCardControls(slider, card) {
    var media = slider.parentElement;
    if (!media || media.querySelector('.fk-qv-btn')) return;
    var n = +slider.getAttribute('data-fk-count') || slider.children.length;
    if (n > 1) {
      ['prev', 'next'].forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'fk-arrow fk-arrow--' + d; b.setAttribute('aria-label', d === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (slider.fkLoadMore) slider.fkLoadMore();
          slider.scrollBy({ left: (d === 'prev' ? -1 : 1) * slider.clientWidth, behavior: 'smooth' });
        });
        media.appendChild(b);
      });
    }
    var h = handleFrom(card);
    if (h) {
      var q = document.createElement('button');
      q.type = 'button'; q.className = 'fk-qv-btn'; q.setAttribute('aria-label', 'Quick view');
      q.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg><span>Quick view</span>';
      q.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var cols = []; try { cols = JSON.parse(card.getAttribute('data-fk-colors') || '[]'); } catch (_) {} openQuickView(h, cols); });
      media.appendChild(q);
    }
  }

  /* ---------- colour -> images (alt text convention: colour name, or "all" for shared images) ---------- */
  function fkNorm(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function colorInfo(p) {
    var ci = -1;
    (p.options || []).forEach(function (o, i) { if (ci < 0 && /colou?r/i.test(o.name)) ci = i; });
    if (ci < 0) return null;
    var map = {}, groups = {};
    p.variants.forEach(function (v) {
      var key = fkNorm(v['option' + (ci + 1)]);
      map[key] = map[key] || {}; map[key][key] = 1; groups[key] = 1;
      var fi = v.featured_image || (v.featured_media && v.featured_media.preview_image);
      var a = fi && fi.alt ? fkNorm(fi.alt) : '';
      if (a && a !== 'all') { map[key][a] = 1; groups[a] = 1; }
    });
    return { map: map, groups: groups };
  }
  function showForColor(alt, colorKey, info) {
    var a = fkNorm(alt);
    if (!info || !colorKey || !a || a === 'all') return true;
    /* any other label is treated as belonging to a colour (e.g. an unused "beige" group): hidden unless it maps to the selected colour */
    return !!(info.map[colorKey] && info.map[colorKey][a]);
  }

  /* ---------- product page: show only the selected colour's photos ---------- */
  var pdpInfo = null;
  function selectedColorKey() {
    var key = '';
    document.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (key || !lg || !/^\s*colou?r/i.test(lg.textContent)) return;
      var chk = fs.querySelector('input:checked');
      key = fkNorm(chk ? chk.value : lg.textContent.split(':').slice(1).join(':'));
    });
    return key;
  }
  function applyPdpFilter() {
    if (!pdpInfo) return;
    var key = selectedColorKey();
    if (!key) return;
    var items = document.querySelectorAll('.product__media-list .product__media-item');
    var firstShown = null;
    items.forEach(function (it) {
      var img = it.querySelector('img');
      var alt = it.getAttribute('data-color') || (img && img.alt) || '';
      var ok = showForColor(alt, key, pdpInfo);
      it.classList.toggle('fk-media-hide', !ok);
      it.classList.remove('fk-first');
      if (ok && !firstShown) firstShown = it;
    });
    if (firstShown) firstShown.classList.add('fk-first');
    document.querySelectorAll('.product-media-modal__content > *').forEach(function (it) {
      var img = it.querySelector('img');
      it.classList.toggle('fk-media-hide', !showForColor(it.getAttribute('data-color') || (img && img.alt) || '', key, pdpInfo));
    });
    document.querySelectorAll('.thumbnail-list > *').forEach(function (it) {
      var img = it.querySelector('img');
      it.classList.toggle('fk-media-hide', !showForColor(it.getAttribute('thumbnail-color') || (img && img.alt) || '', key, pdpInfo));
    });
    var sl = document.querySelector('.product__media-list');
    if (sl) sl.scrollLeft = 0;
    var tags = document.querySelector('.fk-tags--product');
    if (tags && firstShown) { var host = firstShown.querySelector('.product-media-container, .global-media-settings, .media') || firstShown; if (tags.parentElement !== host) { if (getComputedStyle(host).position === 'static') host.style.position = 'relative'; host.appendChild(tags); } }
  }
  function initPdpColor() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || !document.querySelector('.product__media-list') || window.__fkPdpColor) return;
    window.__fkPdpColor = true;
    fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      pdpInfo = colorInfo(p);
      applyPdpFilter();
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.product-form__input')) setTimeout(applyPdpFilter, 60); });
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product-form__input label')) { setTimeout(applyPdpFilter, 120); setTimeout(applyPdpFilter, 600); } });
      new MutationObserver(function () { clearTimeout(window.__fkPdpT); window.__fkPdpT = setTimeout(applyPdpFilter, 80); }).observe(document.querySelector('.product__media-list'), { childList: true });
    }).catch(function () {});
  }

  /* ---------- quick view modal ---------- */
  var qvEl = null;
  function money(c) { return 'Rs. ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function closeQuickView() {
    if (!qvEl) return;
    qvEl.classList.remove('is-open');
    document.documentElement.classList.remove('fk-qv-open');
    var el = qvEl; qvEl = null;
    setTimeout(function () { el.remove(); }, 350);
  }
  function openQuickView(handle, colors) {
    if (qvEl) closeQuickView();
    var root = document.createElement('div');
    root.className = 'fk-qv';
    root.innerHTML = '<div class="fk-qv__backdrop"></div><div class="fk-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="fk-qv__close" aria-label="Close"></button><div class="fk-qv__body"><div class="fk-qv__loading"><i></i></div></div></div>';
    document.body.appendChild(root);
    qvEl = root;
    document.documentElement.classList.add('fk-qv-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    root.querySelector('.fk-qv__backdrop').addEventListener('click', closeQuickView);
    root.querySelector('.fk-qv__close').addEventListener('click', closeQuickView);
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      if (qvEl !== root) return;
      renderQuickView(root, p, colors || []);
    }).catch(function () {
      root.querySelector('.fk-qv__body').innerHTML = '<p class="fk-qv__err">Could not load this product. <a href="/products/' + handle + '">Open the product page</a></p>';
    });
  }
  function renderQuickView(root, p, colors) {
    var allImgs = p.images && p.images.length ? p.images : (p.featured_image ? [p.featured_image] : []);
    var allAlts = allImgs.map(function (u, i) { var m = (p.media || []).filter(function (x) { return x.media_type === 'image' || !x.media_type; })[i]; return m && m.alt ? m.alt : ''; });
    var cInfo = colorInfo(p);
    var imgs = allImgs.slice();
    var opts = p.options || [];
    var sel = {};
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    opts.forEach(function (o, i) { sel[i] = first['option' + (i + 1)]; });
    function colorKeyNow() {
      var ci = -1; opts.forEach(function (o, i) { if (ci < 0 && /colou?r/i.test(o.name)) ci = i; });
      return ci < 0 ? '' : fkNorm(sel[ci]);
    }
    function filteredImgs() {
      var key = colorKeyNow();
      if (!cInfo || !key) return allImgs.slice();
      var out = allImgs.filter(function (u, i) { return showForColor(allAlts[i], key, cInfo); });
      return out.length ? out : allImgs.slice();
    }
    imgs = filteredImgs();
    var lastKey = colorKeyNow();
    function sized(u, w) { return u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
    var thumbs = imgs.map(function (u, i) { return '<button type="button" class="fk-qv__thumb' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '"><img src="' + sized(u, 160) + '" alt="" loading="lazy"></button>'; }).join('');
    var slides = imgs.map(function (u) { return '<div class="fk-qv__slide"><img src="' + sized(u, 900) + '" alt="' + esc(p.title) + '"></div>'; }).join('');
    function colorFor(v) {
      var k = String(v).toLowerCase();
      var rec = colors.filter(function (c) { return String(c.n).trim().toLowerCase() === k.trim(); })[0];
      if (rec) { var ov = FK_OVERRIDE[k.trim()]; return ov ? { n: rec.n, c: ov, i: null } : rec; }
      var cs = colorsFor(v);
      return cs.length ? { n: v, c: cs.length === 1 ? cs[0] : null, g: cs } : null;
    }
    var optHtml = opts.map(function (o, i) {
      var vals = o.values || [];
      var isColor = /colou?r/i.test(o.name) && vals.some(function (v) { return colorFor(v); });
      return '<fieldset class="fk-qv__opt' + (isColor ? ' fk-qv__opt--color' : '') + '" data-i="' + i + '"><legend>' + esc(o.name) + ': <b>' + esc(sel[i]) + '</b></legend><div class="fk-qv__vals">' +
        vals.map(function (v) {
          var c = isColor ? colorFor(v) : null;
          if (c) {
            var bg = c.i ? 'url(' + c.i + ') center / cover' : (c.g && c.g.length > 1 ? 'linear-gradient(135deg,' + c.g.map(function (x, q) { var w = 100 / c.g.length; return x + ' ' + (q * w) + '%,' + x + ' ' + ((q + 1) * w) + '%'; }).join(',') + ')' : (c.c || '#ccc'));
            return '<button type="button" class="fk-qv__val fk-qv__val--sw" data-v="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '" style="background:' + bg + '"></button>';
          }
          return '<button type="button" class="fk-qv__val" data-v="' + esc(v) + '">' + esc(v) + '</button>';
        }).join('') + '</div></fieldset>';
    }).join('');
    root.querySelector('.fk-qv__body').innerHTML =
      '<div class="fk-qv__gallery' + (imgs.length < 2 ? ' is-single' : '') + '"><div class="fk-qv__slides">' + slides + '</div>' +
      '<button type="button" class="fk-qv__nav fk-qv__nav--prev" aria-label="Previous image"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="fk-qv__nav fk-qv__nav--next" aria-label="Next image"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<span class="fk-qv__count"></span><div class="fk-qv__dots">' + imgs.map(function (u, i) { return '<i class="' + (i === 0 ? 'is-on' : '') + '"></i>'; }).join('') + '</div>' +
      '<div class="fk-qv__thumbs">' + thumbs + '</div></div>' +
      '<div class="fk-qv__info"><h3 class="fk-qv__title">' + esc(p.title) + '</h3><div class="fk-qv__price"></div>' + optHtml +
      '<div class="fk-qv__actions"><button type="button" class="fk-qv__add">Add to cart</button><a class="fk-qv__more" href="/products/' + p.handle + '">View full details</a></div><p class="fk-qv__msg" role="status"></p></div>';
    var slidesEl = root.querySelector('.fk-qv__slides');
    function variant() {
      return p.variants.filter(function (v) { return opts.every(function (o, i) { return v['option' + (i + 1)] === sel[i]; }); })[0];
    }
    function rebuild() {
      imgs = filteredImgs();
      slidesEl.innerHTML = imgs.map(function (u) { return '<div class="fk-qv__slide"><img src="' + sized(u, 900) + '" alt="' + esc(p.title) + '"></div>'; }).join('');
      root.querySelector('.fk-qv__thumbs').innerHTML = imgs.map(function (u, i) { return '<button type="button" class="fk-qv__thumb' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '"><img src="' + sized(u, 160) + '" alt="" loading="lazy"></button>'; }).join('');
      root.querySelector('.fk-qv__dots').innerHTML = imgs.map(function (u, i) { return '<i class="' + (i === 0 ? 'is-on' : '') + '"></i>'; }).join('');
      root.querySelector('.fk-qv__gallery').classList.toggle('is-single', imgs.length < 2);
      slidesEl.scrollLeft = 0;
      syncNav();
    }
    function sync() {
      var v = variant();
      var nowKey = colorKeyNow();
      if (nowKey !== lastKey) { lastKey = nowKey; rebuild(); }
      root.querySelectorAll('.fk-qv__opt').forEach(function (fs) {
        var i = +fs.dataset.i;
        fs.querySelector('legend b').textContent = sel[i];
        fs.querySelectorAll('.fk-qv__val').forEach(function (b) {
          var val = b.dataset.v;
          b.classList.toggle('is-on', val === sel[i]);
          var test = p.variants.some(function (x) {
            return x['option' + (i + 1)] === val && x.available && opts.every(function (o, j) { return j === i || x['option' + (j + 1)] === sel[j]; });
          });
          b.classList.toggle('is-out', !test);
        });
      });
      var price = root.querySelector('.fk-qv__price');
      if (v) {
        price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + '<span>' + money(v.price) + '</span>';
        var add = root.querySelector('.fk-qv__add');
        add.disabled = !v.available;
        add.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.featured_image && imgs.length) {
          var idx = imgs.findIndex(function (u) { return u.split('?')[0] === v.featured_image.src.split('?')[0]; });
          if (idx > -1) slidesEl.scrollTo({ left: idx * slidesEl.clientWidth, behavior: 'smooth' });
        }
      } else {
        price.innerHTML = '<span>Unavailable</span>';
        root.querySelector('.fk-qv__add').disabled = true;
      }
    }
    root.querySelectorAll('.fk-qv__opt').forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('.fk-qv__val'); if (!b) return;
        sel[+fs.dataset.i] = b.dataset.v; sync();
      });
    });
    root.querySelector('.fk-qv__gallery').addEventListener('click', function (e) {
      var t = e.target.closest('.fk-qv__thumb');
      if (t) slidesEl.scrollTo({ left: +t.dataset.i * slidesEl.clientWidth, behavior: 'smooth' });
    });
    var prevB = root.querySelector('.fk-qv__nav--prev'), nextB = root.querySelector('.fk-qv__nav--next'), cnt = root.querySelector('.fk-qv__count');
    function syncNav() {
      var i = Math.round(slidesEl.scrollLeft / slidesEl.clientWidth);
      root.querySelectorAll('.fk-qv__thumb').forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      root.querySelectorAll('.fk-qv__dots i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (cnt) cnt.textContent = (i + 1) + ' / ' + imgs.length;
      if (prevB) prevB.disabled = i <= 0;
      if (nextB) nextB.disabled = i >= imgs.length - 1;
    }
    if (prevB) prevB.addEventListener('click', function () { slidesEl.scrollBy({ left: -slidesEl.clientWidth, behavior: 'smooth' }); });
    if (nextB) nextB.addEventListener('click', function () { slidesEl.scrollBy({ left: slidesEl.clientWidth, behavior: 'smooth' }); });
    slidesEl.addEventListener('scroll', syncNav, { passive: true });
    syncNav();
    document.addEventListener('keydown', function qvKeys(e) {
      if (!document.body.contains(root)) { document.removeEventListener('keydown', qvKeys); return; }
      if (e.key === 'ArrowRight' && nextB) nextB.click();
      if (e.key === 'ArrowLeft' && prevB) prevB.click();
    });
    root.querySelector('.fk-qv__add').addEventListener('click', function () {
      var v = variant(); if (!v || !v.available) return;
      var btn = this, msg = root.querySelector('.fk-qv__msg');
      btn.disabled = true; btn.classList.add('is-busy'); msg.textContent = '';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: v.id, quantity: 1 }] };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.classList.remove('is-busy'); btn.disabled = false;
          if (res.status && res.status !== 200 || res.description && !res.items) { msg.textContent = res.description || res.message || 'Could not add this item.'; return; }
          closeQuickView();
          if (drawer && drawer.renderContents) {
            setTimeout(function () { drawer.classList.remove('is-empty'); drawer.renderContents(res); drawer.classList.remove('is-empty'); }, 200);
          } else { window.location.href = '/cart'; }
        }).catch(function () { btn.classList.remove('is-busy'); btn.disabled = false; msg.textContent = 'Network error, please try again.'; });
    });
    sync();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });

  /* ---------- product card image slider ---------- */
  function initSlider(el) {
    if (el.dataset.fkInit) return;
    el.dataset.fkInit = '1';
    var card = el.closest('.fk-card');
    addCardControls(el, card);
    var thumb = card && card.querySelector('.fk-track i');
    var track = card && card.querySelector('.fk-track');
    var slides = +el.getAttribute('data-fk-count') || el.children.length;
    function update() {
      var max = el.scrollWidth - el.clientWidth;
      var p = max > 0 ? el.scrollLeft / max : 0;
      if (thumb) thumb.style.transform = 'translateX(' + (p * (slides - 1) * 100) + '%)';
    }
    /* the extra photos are built (and fetched) only when the card is touched, hovered, focused or swiped */
    var built = false;
    var loadMore = function () {
      if (built) return; built = true;
      try {
        var extra = JSON.parse(el.getAttribute('data-fk-extra') || '[]');
        var href = (el.querySelector('.fk-slide') || {}).href || '#';
        var label = (el.querySelector('.fk-slide') || {}).getAttribute ? el.querySelector('.fk-slide').getAttribute('aria-label') : '';
        var sizes = (el.querySelector('img') || {}).sizes || '';
        extra.forEach(function (x) {
          var a = document.createElement('a'); a.className = 'fk-slide'; a.href = href; a.tabIndex = -1; a.setAttribute('aria-label', label || '');
          var im = document.createElement('img');
          im.srcset = x.t + ' 360w, ' + x.s + ' 533w, ' + x.u + ' 720w'; im.src = x.s; im.sizes = sizes; im.alt = x.a || '';
          im.width = x.w; im.height = x.h; im.draggable = false; im.decoding = 'async';
          a.appendChild(im); el.appendChild(a);
        });
        el.removeAttribute('data-fk-extra');
      } catch (e) {}
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { card && card.removeEventListener(ev, loadMore); });
    };
    el.fkLoadMore = loadMore;
    if (card && el.getAttribute('data-fk-extra')) ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { card.addEventListener(ev, loadMore, { passive: true, once: true }); });
    el.addEventListener('scroll', update, { passive: true });
    update();
    /* click on track scrubs */
    if (track) {
      track.addEventListener('click', function (e) {
        var r = track.getBoundingClientRect();
        var f = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        el.scrollTo({ left: Math.round(f * (slides - 1)) * el.clientWidth, behavior: 'smooth' });
        e.preventDefault();
      });
    }
    /* mouse drag */
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft;
      el.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) moved = true;
      el.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; el.classList.remove('is-drag');
      var i = Math.round(el.scrollLeft / el.clientWidth);
      el.scrollTo({ left: i * el.clientWidth, behavior: 'smooth' });
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function initSliders(root) {
    (root || document).querySelectorAll('[data-fk-slider]').forEach(initSlider);
  }

  /* ---------- product tabs ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('.fk-tabs').forEach(function (box) {
      if (box.dataset.fkInit) return;
      box.dataset.fkInit = '1';
      var btns = box.querySelectorAll('[role=tab]');
      var panes = box.querySelectorAll('[role=tabpanel]');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
          panes.forEach(function (p, j) { p.hidden = i !== j; });
        });
      });
    });
  }

  /* ---------- size guide: bottom sheet that closes on backdrop / Esc ---------- */
  function initSizeGuide() {
    if (document.body.dataset.fkSize) return;
    document.body.dataset.fkSize = '1';
    function pop() { return document.querySelector('.size-guide-popup'); }
    function close() {
      var p = pop();
      if (p) { p.style.display = 'none'; }
      document.querySelectorAll('.size-guide-overlay').forEach(function (o) { if (!o.classList.contains('cross-icon')) o.style.display = 'none'; });
      document.documentElement.classList.remove('fk-size-open');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.size-guide-link')) {
        setTimeout(function () {
          var p = pop();
          document.documentElement.classList.toggle('fk-size-open', !!p && getComputedStyle(p).display !== 'none');
        }, 30);
      } else if (e.target.closest('.size-guide-popup .cross-icon')) {
        close();
      } else if (document.documentElement.classList.contains('fk-size-open') && !e.target.closest('.size-guide-popup')) {
        close();
      }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* sticky product card: when taller than the viewport, stick by its bottom edge so nothing is unreachable */
  function stickyInfo() {
    var w = document.querySelector('.product__info-wrapper');
    if (!w) return;
    if (!w.dataset.fkSticky) {
      w.dataset.fkSticky = '1';
      if (window.ResizeObserver) new ResizeObserver(stickyInfo).observe(w);
      window.addEventListener('resize', stickyInfo);
    }
    var h = w.offsetHeight, vh = window.innerHeight, top = 86;
    w.style.top = (h + top + 16 > vh ? vh - h - 16 : top) + 'px';
  }

  /* hero videos: browsers sometimes need an explicit play() even when muted + autoplay */
  function playVideos() {
    var vids = document.querySelectorAll('video[data-fk-video]');
    if (!vids.length) return;
    function start() {
      vids.forEach(function (v) {
        if (v.offsetParent === null && getComputedStyle(v).display === 'none') return; /* the hidden desktop/mobile twin */
        v.muted = true; v.preload = 'auto';
        var r = v.play(); if (r && r.catch) r.catch(function () {});
      });
    }
    /* poster paints first; the video begins once the page has loaded and the browser is idle */
    var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(start, { timeout: 2500 }); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    document.addEventListener('click', function () { vids.forEach(function (v) { if (v.paused && v.offsetParent !== null) v.play().catch(function () {}); }); }, { once: true });
  }

  /* ---------- back-to-top: round button with a scroll-progress ring ---------- */
  function initToTop() {
    if (document.querySelector('.fk-totop')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'fk-totop'; b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg class="fk-totop__ring" viewBox="0 0 48 48" aria-hidden="true"><circle class="fk-totop__bg" cx="24" cy="24" r="21"/><circle class="fk-totop__bar" cx="24" cy="24" r="21"/></svg>' +
      '<svg class="fk-totop__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V6M6 11.5 12 5.5l6 6"/></svg>';
    document.body.appendChild(b);
    var bar = b.querySelector('.fk-totop__bar'), C = 2 * Math.PI * 21, tick = false;
    bar.style.strokeDasharray = C;
    function upd() {
      tick = false;
      var max = document.documentElement.scrollHeight - window.innerHeight, y = window.pageYOffset || 0;
      bar.style.strokeDashoffset = C * (1 - (max > 0 ? Math.min(1, y / max) : 0));
      b.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    upd();
  }

  /* ---------- size chart link sits in a row with the price ---------- */
  function moveSizeLink() {
    var link = document.querySelector('.size-guide-link');
    var price = document.querySelector('.product__info-container [id^="price-"]');
    if (!link || !price || price.parentElement.classList.contains('fk-pricerow')) return;
    var row = document.createElement('div');
    row.className = 'fk-pricerow';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    row.appendChild(link);
  }

  /* ---------- the size chart popup is moved to <body> so it always sits above the backdrop ---------- */
  function liftSizePopup() {
    var p = document.querySelector('.size-guide-popup');
    if (p && p.parentElement !== document.body) document.body.appendChild(p);
  }

  /* ---------- tags on the product page gallery ---------- */
  function initProductTags() {
    var t = window.FK_TAGS;
    if (!t || (!t.isNew && !t.oversize)) return;
    var first = document.querySelector('.product__media-list .product__media-item');
    var host = first && (first.querySelector('.product-media-container, .global-media-settings, .media') || first);
    if (!host || host.querySelector('.fk-tags')) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var box = document.createElement('div');
    box.className = 'fk-tags fk-tags--product';
    box.setAttribute('aria-hidden', 'true');
    if (t.isNew) box.insertAdjacentHTML('beforeend', '<span class="fk-tag fk-tag--new">New Arrivals</span>');
    if (t.oversize) box.insertAdjacentHTML('beforeend', '<span class="fk-tag fk-tag--fit">Oversize Fit</span>');
    host.appendChild(box);
  }

  /* ---------- colour swatches: fill in colours for options that have no colour record ---------- */
  var FK_COLORS = {"white":"#ffffff","black":"#000000","yellow":"#f9d168","olive green":"#453e2f","baby blue":"#a4cef8","beige":"#ebcd8b","bottle green":"#22482e","charcoal melange":"#6e6e6e","coffee brown":"#1c100f","copper":"#c2745f","coral":"#c86e4e","brick red":"#7b2f1d","flag green":"#159512","flamingo":"#e29891","golden yellow":"#ef9a31","grey melange":"#c3c3c3","jade":"#ccf5c9","khaki":"#9d6333","lavender":"#bbb1d2","light pink":"#ffd5db","maroon":"#2d0101","mint":"#bffcf7","mushroom":"#cc9d93","mustard yellow":"#cf8f26","navy blue":"#2d314a","new yellow":"#fcfa30","orange":"#e65e00","peach":"#ffdec6","petrol blue":"#002a2f","pink":"#cc2867","purple":"#321541","red":"#a50303","royal blue":"#1f286a","sky blue":"#19e4ff","steel grey":"#3a3e41","off white":"#fffeec","cream":"#f6ead4","tan":"#a4775b","pista":"#adb690","fuchsia":"#e9074f","brown":"#6b4226","light baby pink":"#ffd5db","baby pink":"#ffd5db","navy":"#2d314a","grey":"#9a9a9a","gray":"#9a9a9a","green":"#2e7d32","blue":"#2f5fb3","lilac":"#bbb1d2"};
  var FK_OVERRIDE = { 'coffee brown': '#6b4430' };
  var FK_KEYS = Object.keys(FK_COLORS).sort(function (a, b) { return b.length - a.length; });
  function colorsFor(name) {
    var n = String(name || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (FK_COLORS[n]) return [FK_COLORS[n]];
    var found = [], rest = ' ' + n + ' ';
    FK_KEYS.forEach(function (k) {
      var re = ' ' + k + ' ';
      var i = rest.indexOf(re);
      if (i > -1) { found.push({ at: i, c: FK_COLORS[k] }); rest = rest.slice(0, i) + ' '.repeat(re.length) + rest.slice(i + re.length); }
    });
    found.sort(function (a, b) { return a.at - b.at; });
    return found.map(function (f) { return f.c; });
  }
  function initSwatches(root) {
    (root || document).querySelectorAll('.fk-swatch-js:not([data-fk-done])').forEach(function (el) {
      el.dataset.fkDone = '1';
      var cs = colorsFor(el.getAttribute('data-color-name'));
      if (cs.length === 1) el.style.background = cs[0];
      else if (cs.length > 1) el.style.background = 'linear-gradient(135deg, ' + cs.map(function (c, i) { var p = 100 / cs.length; return c + ' ' + (i * p) + '%, ' + c + ' ' + ((i + 1) * p) + '%'; }).join(', ') + ')';
    });
  }

  /* ---------- on-this-page navigation for legal pages ---------- */
  function initToc() {
    var list = document.querySelector('[data-fk-toc]');
    var prose = document.querySelector('[data-fk-prose]');
    if (!list || !prose || list.dataset.fkInit) return;
    list.dataset.fkInit = '1';
    var heads = prose.querySelectorAll('h2');
    if (heads.length < 3) { var aside = list.closest('.fk-toc'); if (aside) aside.remove(); var pb = document.querySelector('.fk-pagebody'); if (pb) pb.classList.remove('has-toc'); return; }
    var links = [];
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim();
      li.appendChild(a); list.appendChild(li); links.push({ a: a, h: h });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { links.forEach(function (l) { l.a.classList.toggle('is-on', l.h === e.target); }); }
        });
      }, { rootMargin: '-110px 0px -65% 0px' });
      links.forEach(function (l) { io.observe(l.h); });
    }
  }

  /* ---------- collection description: collapsed card with a read more toggle ---------- */
  function initSeo() {
    document.querySelectorAll('[data-fk-seo]').forEach(function (body) {
      if (body.dataset.fkInit) return;
      body.dataset.fkInit = '1';
      var card = body.closest('.fk-seo__card');
      var btn = card.querySelector('[data-fk-seo-toggle]');
      var content = body.querySelector('.fk-seo__content');
      content.querySelectorAll('p').forEach(function (p) {
        var t = p.textContent;
        if ((t.match(/\|/g) || []).length >= 3) {
          var chips = t.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
          var wrap = document.createElement('div'); wrap.className = 'fk-seo__chips';
          chips.forEach(function (c) { var s = document.createElement('span'); s.textContent = c; wrap.appendChild(s); });
          p.replaceWith(wrap);
        }
      });
      content.querySelectorAll('a[target="_blank"]').forEach(function (a) { a.removeAttribute('target'); });
      function measure() {
        card.classList.remove('is-collapsed');
        var full = content.scrollHeight;
        if (full > 340) { card.classList.add('is-collapsed'); btn.hidden = false; }
        else { btn.hidden = true; }
      }
      measure();
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      window.addEventListener('resize', function () { if (!card.classList.contains('is-open')) measure(); });
    });
  }

  function init() { initSeo(); initPdpColor(); initProductTags(); initSwatches(); initToc(); liftSizePopup(); moveSizeLink(); initToTop(); playVideos(); stickyInfo(); initMenu(); initSliders(); initTabs(); initSizeGuide(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initMenu(); initSliders(e.target); initTabs(e.target); });
  /* cards injected later (pagination / filtering / quick view): only look at what was actually added */
  var pending = false;
  new MutationObserver(function (muts) {
    if (pending) return;
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes;
      for (var k = 0; k < add.length; k++) {
        var n = add[k];
        if (n.nodeType === 1 && (n.matches('[data-fk-slider],.fk-card,.fk-tabs,.fk-swatch-js,[data-fk-seo],[data-fk-toc]') || n.querySelector('[data-fk-slider],.fk-tabs,.fk-swatch-js,[data-fk-seo],[data-fk-toc],.fk-burger'))) {
          pending = true;
          (window.requestIdleCallback || function (f) { setTimeout(f, 80); })(function () { pending = false; initSliders(); initTabs(); initMenu(); initSwatches(); initToc(); initSeo(); }, { timeout: 400 });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
